import React from 'react';
import { IBRMInputDataRequiredInput } from 'src/common/api/brm/brm-utils';
import InteractiveDialogContent from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import InteractiveDialogueContainer from '../../../common/components/interactive-dialogue/components/interactive-dialogue-container';
import { pushEmeraldModal } from '../../../common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from '../../../common/enumerations/emerald-dialog-types';
import InputDataButtons from './components/input-data-required-yesno-buttons/input-data-required-yesno-buttons';

type Props = IInputDataRequiredState;

export const showInputDataRequiredYesNoDialog = (props: Props) => {
  pushEmeraldModal(<InputDataRequiredYesNoModal {...props} />);
};

const InputDataRequiredYesNoModal: React.FC<Props> = (props: Props): JSX.Element => {
  const { message, submessage, onAccept, onCancel, inputName } = props;

  return (
    <InteractiveDialogueContainer
      dialogTestIdPrefix='input-data-required'
      open={true}
      handleClose={onCancel}
      handleAccept={() => {}}
      component={
        <InteractiveDialogContent
          type={EmeraldDialogTypes.InfoDecision}
          message={message}
          subMessage={submessage}
        ></InteractiveDialogContent>
      }
      buttonComponent={
        <InputDataButtons onCancel={onCancel} onAccept={onAccept} inputName={inputName} />
      }
    />
  );
};

interface IInputDataRequiredState {
  message?: string;
  submessage: string;
  onCancel: () => void;
  onAccept: (inputData: IBRMInputDataRequiredInput) => void;
  inputName?: string;
}

export default InputDataRequiredYesNoModal;
